import { Box, FormikRadioGroup } from '@palmetto/palmetto-components';
import { useFormikContext, Field } from 'formik';
import { Dispatch, SetStateAction, SyntheticEvent } from 'react';

import { Locale } from 'types';

export const ApplicationPreferredLanguage = ({
  isCreditApproved,
  isSubmitting,
  isLoading,
  setPreferredLanguage,
}: {
  isCreditApproved?: boolean;
  isSubmitting: boolean;
  isLoading: boolean;
  setPreferredLanguage?: Dispatch<SetStateAction<Locale>>;
}) => {
  const { initialValues, setFieldValue }: any = useFormikContext<any>();
  return (
    <Box direction={{ base: 'column', desktop: 'row' }} childGap={{ base: 'lg', desktop: 'xl' }}>
      <Box margin={{ base: '0', desktop: 'lg 0 0 0' }}>
        <Field
          name={`language`}
          id={`language`}
          component={FormikRadioGroup}
          isRequired
          isDisabled={isSubmitting || isLoading || (initialValues?.language && isCreditApproved)}
          onChange={(data: SyntheticEvent<HTMLInputElement>) => {
            const selectedValue = (data.target as HTMLInputElement).value;
            setFieldValue('language', selectedValue);
            setPreferredLanguage?.(selectedValue as Locale);
          }}
          options={[
            { label: 'English', value: Locale.en },
            { label: 'Spanish', value: Locale.es },
          ]}
        />
      </Box>
    </Box>
  );
};
